import Helmet from 'react-helmet';

interface GaiaHelmetProps {
    canonicalUrl?: string;
    description?: string;
    jsonLd?: Record<string, any>;
    openGraphTitle?: string;
    openGraphUrl?: string;
    revisitAfter?: string;
    stylesheets?: string[];
    title?: string;
}

export default function GaiaHelmet({
    canonicalUrl,
    jsonLd,
    stylesheets,
    description = 'Plan trips and record GPS tracks for free, with the best app for backcountry hiking, ski touring, and offroad camping trips. Buy a membership to download maps, including topos, aerial imagery, public/private land ownership, and National Geographic.',
    openGraphTitle = 'Gaia GPS: Navigate, Track, and Explore',
    openGraphUrl = 'https://www.gaiagps.com',
    revisitAfter = '1 day',
    title = 'Hiking Trail Maps, Ski Touring, 4x4 Offroad App | Gaia GPS',
}: GaiaHelmetProps) {
    return (
        <Helmet>
            <title>{title}</title>
            <meta
                name='description'
                data-react-helmet='true'
                content={description}
            />
            {stylesheets
                ? stylesheets.map((value, index) => {
                      return (
                          <link
                              rel='stylesheet'
                              type='text/css'
                              key={index}
                              href={value}
                          />
                      );
                  })
                : ''}
            <meta name='revisit-after' content={revisitAfter} />
            <meta property='og:site_name' content='GaiaGPS.com' />
            {canonicalUrl && <link rel='canonical' href={canonicalUrl} />}
            <link rel='manifest' href='@static/manifest.json' />
            <meta property='og:type' content='website' />
            <meta property='og:url' content={openGraphUrl} />
            <meta property='og:title' content={openGraphTitle} />
            <meta property='og:description' content={description} />
            <meta
                property='og:image'
                content='@static/img/gaia-gps-social.jpg'
            />
            <meta name='twitter:title' content={openGraphTitle} />
            <meta name='twitter:site' content='@gaiagps' />
            <meta name='twitter:description' content={description} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta
                name='twitter:image:src'
                content='@static/img/gaia-gps-social.jpg'
            />
            <script type='application/ld+json'>
                {JSON.stringify(
                    jsonLd || {
                        '@context': 'http://schema.org/',
                        '@type': 'Organization',
                        '@id': 'https://www.gaiagps.com/company/',
                        name: 'TrailBehind, Inc.',
                        foundingDate: '2008',
                        brand: {
                            '@type': 'Brand',
                            '@id': 'https://www.gaiagps.com/',
                            name: 'Gaia GPS',
                            logo: '@static/img/logos_icons/gaia-gps_logo.png',
                        },
                        founder: [
                            {
                                '@type': 'Person',
                                givenName: 'Andrew',
                                familyName: 'Johnson',
                                jobTitle: 'CEO',
                            },
                            {
                                '@type': 'Person',
                                givenName: 'Anna',
                                familyName: 'Johnson',
                                jobTitle: 'CTO',
                            },
                            {
                                '@type': 'Person',
                                givenName: 'Jesse',
                                familyName: 'Crocker',
                                jobTitle: 'Engineering Manager',
                            },
                        ],
                    }
                )}
            </script>
        </Helmet>
    );
}
